if (!customElements.get('sd-hero')) {
  customElements.define('sd-hero', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const opts = {signal:this.controller.signal};
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.active = 0;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      this.hovered = false;
      this.pauseButton = this.querySelector('[data-pause]');
      this.querySelector('[data-prev]')?.addEventListener('click',()=>this.choose(this.active-1),opts);
      this.querySelector('[data-next]')?.addEventListener('click',()=>this.choose(this.active+1),opts);
      this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>this.choose(i),opts));
      this.pauseButton?.addEventListener('click',()=>{this.paused=!this.paused;this.updatePause();this.schedule();},opts);
      this.addEventListener('mouseenter',()=>{this.hovered=true;this.schedule();},opts);
      this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule();},opts);
      this.addEventListener('focusin',e=>{if(e.target!==this.pauseButton){this.paused=true;this.updatePause();this.schedule();}},opts);
      this.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();this.choose(this.active+(e.key==='ArrowRight'?1:-1));}},opts);
      this.addEventListener('pointerdown',e=>{if(e.pointerType==='touch'){this.touchX=e.clientX;this.touchY=e.clientY;this.paused=true;this.updatePause();this.schedule();}},opts);
      this.addEventListener('pointerup',e=>{if(e.pointerType==='touch' && this.touchX!=null){const dx=e.clientX-this.touchX,dy=e.clientY-this.touchY;if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy))this.choose(this.active+(dx<0?1:-1));this.touchX=null;}},opts);
      document.addEventListener('visibilitychange',()=>this.schedule(),opts);
      this.reduced.addEventListener('change',()=>{if(this.reduced.matches)this.paused=true;this.updatePause();this.schedule();},opts);
      document.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s===e.target||s.contains(e.target));if(i>=0)this.choose(i);},opts);
      this.updatePause();this.schedule();
    }
    updatePause(){if(this.pauseButton){this.pauseButton.setAttribute('aria-pressed',String(this.paused));this.pauseButton.textContent=this.paused?this.pauseButton.dataset.play:this.pauseButton.dataset.pauseLabel;}}
    show(index){if(!this.slides.length)return;this.active=(index+this.slides.length)%this.slides.length;this.slides.forEach((s,i)=>s.setAttribute('aria-hidden',String(i!==this.active)));this.dots.forEach((d,i)=>d.setAttribute('aria-current',String(i===this.active)));this.schedule();}
    choose(index){this.paused=true;this.updatePause();this.show(index);}
    schedule(){clearTimeout(this.timer);if(!this.isConnected||this.paused||this.hovered||document.hidden||this.slides.length<2)return;this.timer=setTimeout(()=>this.show(this.active+1),Number(this.dataset.interval)||6500);}
    disconnectedCallback(){clearTimeout(this.timer);this.controller?.abort();}
  });
}
if (!customElements.get('sd-brands')) {
  customElements.define('sd-brands', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      clearTimeout(this.scrollTimer);
      this.observer?.disconnect();
      this.controller = new AbortController();
      const opts = {signal: this.controller.signal};
      const button = this.querySelector('[data-brand-pause]');
      const viewport = this.querySelector('.brand-viewport');
      if (!viewport) return;
      button?.addEventListener('click', () => {
        const paused = viewport.classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.play : button.dataset.pauseLabel);
        button.innerHTML = paused
          ? '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="m7 4 14 8-14 8z"/></svg>'
          : '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M9 4v16M15 4v16"/></svg>';
      }, opts);
      const onScroll = () => {
        viewport.classList.add('is-scrolling');
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => viewport.classList.remove('is-scrolling'), 180);
      };
      window.addEventListener('scroll', onScroll, {...opts, passive: true});
      this.closest('.page-wrapper')?.addEventListener('scroll', onScroll, {...opts, passive: true});
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          viewport.classList.toggle('is-offscreen', !entry.isIntersecting);
        }, {root: null, rootMargin: '80px'});
        this.observer.observe(this);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.scrollTimer);
      this.observer?.disconnect();
      this.controller?.abort();
    }
  });
}

// Keep the hero review count on this page instead of opening the app's modal.
window.addEventListener('click', (event) => {
  const trigger = event.target.closest?.('.sd-google-badge [data-repocean-open-reviews], .review-badge[href="#ervaringen"]');
  if (!trigger) return;
  event.preventDefault();
  event.stopImmediatePropagation();

  const reviews = document.getElementById('ervaringen');
  if (!reviews) return;
  const heading = reviews.querySelector('h2');
  if (heading) {
    heading.setAttribute('tabindex', '-1');
    heading.focus({preventScroll: true});
  }
  const headerHeight = document.getElementById('header-group')?.getBoundingClientRect().height || 0;
  const wrapper = reviews.closest('.page-wrapper');
  const scrollsInWrapper = wrapper && /auto|scroll/.test(getComputedStyle(wrapper).overflowY);
  const scroller = scrollsInWrapper ? wrapper : window;
  const scrollTop = scrollsInWrapper ? wrapper.scrollTop : window.scrollY;
  const containerTop = scrollsInWrapper ? wrapper.getBoundingClientRect().top : 0;
  scroller.scrollTo({
    top: Math.max(0, reviews.getBoundingClientRect().top - containerTop + scrollTop - headerHeight - 20),
    behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
  });
}, {capture: true});
